"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bsi_1 = require("./bsi");
var bsiManager = bsi_1.initBsiManager();
var callSafe = function (Wix, fn) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    var _a;
    if (Wix.Utils && typeof Wix.Utils[fn] === 'function') {
        return (_a = Wix.Utils)[fn].apply(_a, args);
    }
};
var ENRICHERS = {
    _msid: function (Wix) { return callSafe(Wix, 'getInstanceValue', 'metaSiteId'); },
    _appId: function (Wix) { return callSafe(Wix, 'getInstanceValue', 'appDefId'); },
    _instanceId: function (Wix) { return callSafe(Wix, 'getInstanceId'); },
    _siteOwnerId: function (Wix) { return callSafe(Wix, 'getSiteOwnerId'); },
    _siteMemberId: function (Wix) { return function () { return callSafe(Wix, 'getUid') || ''; }; },
    _visitorId: function (Wix) { return function () { return callSafe(Wix, 'getInstanceValue', 'aid'); }; },
    _viewMode: function (Wix) { return callSafe(Wix, 'getViewMode'); },
    _uuid: {
        enabled: function (Wix) { return callSafe(Wix, 'getViewMode') === 'editor'; },
        value: function (Wix) { return callSafe(Wix, 'getUid') || ''; },
    },
    _bsi: function (Wix) { return function () { return exports.getBsi(Wix); }; },
};
exports.getBsi = function (Wix) { return bsiManager && bsiManager.getBsi(Wix); };
function getBiContext(Wix) {
    if (!Wix) {
        return {};
    }
    return Object.keys(ENRICHERS).reduce(function (res, field) {
        var prop = ENRICHERS[field];
        if (typeof prop === 'function') {
            res[field] = prop(Wix);
        }
        else if (prop.enabled(Wix)) {
            res[field] = prop.value(Wix);
        }
        return res;
    }, {});
}
exports.getBiContext = getBiContext;
//# sourceMappingURL=index.js.map